<template>
  <div class="product-detail">
    <div class="detail-inner">
      <div class="content-col">
        <h1 class="product-title">{{ item.title }}</h1>
        <img v-if="item.imageurl" class="top-img" :src="item.imageurl" alt="">
        <div class="content" v-html="autoLink(item.content)"></div>
        <img v-if="item.imageurl2" class="top-img top-img-2" :src="item.imageurl2" alt="">
        <div class="content" v-html="autoLink(item.content2)"></div>
      </div>

      <aside v-if="purchases.length" class="buy-panel">
        <div class="buy-title">ご購入</div>
        <div class="buy-list">
          <div class="buy-item" v-for="(p, i) in purchases" :key="i">
            <div class="buy-name">{{ p.title }}</div>
            <a class="buy-btn" :href="p.url" target="_blank">ご購入はこちら</a>
          </div>
        </div>
      </aside>
    </div>
  </div>
</template>

<script>
import firebase from "../main.js"
import { doc, getDoc } from "firebase/firestore";

export default {
  name: 'ProductDetail',
  data() {
    return {
      id: null,
      item: {},
    }
  },
  computed: {
    purchases() {
      const list = [];
      for (let i = 1; i <= 10; i++) {
        if (this.item['title' + i]) {
          list.push({ title: this.item['title' + i], url: this.item['url' + i] });
        }
      }
      return list;
    }
  },
  created() {
    this.id = this.$route.query.id;
  },
  mounted() {
    this.awaitFunc();
  },
  methods: {
    autoLink(text) {
      return text ? text.replace(/(https?:\/\/[^\s]*)/g, "<a href='$1' style='color:#AF9453;text-decoration:underline;' target='_blank'>$1</a>") : '';
    },
    async awaitFunc() {
      const docRef = doc(firebase.db, "Products", this.id);
      const querySnapshot = await getDoc(docRef);
      this.item = querySnapshot.data();
      const bucket = "farmy-demo.appspot.com";
      if (this.item.imageurl) {
        const path = encodeURIComponent("products-contents-image/" + this.item.imageurl);
        this.item.imageurl = `https://firebasestorage.googleapis.com/v0/b/${bucket}/o/${path}?alt=media`;
      }
      if (this.item.imageurl2) {
        const path = encodeURIComponent("products-contents-image/" + this.item.imageurl2);
        this.item.imageurl2 = `https://firebasestorage.googleapis.com/v0/b/${bucket}/o/${path}?alt=media`;
      }
      if (this.item.content.indexOf("gagagagazou") >= 0) {
        let contents = this.item.content.split("gagagagazou");
        this.item.content = contents[0];
        this.item.content2 = contents[1];
      }
    },
  }
}
</script>

<style scoped>
.product-detail {
  padding: 28px 16px 64px;
}
.detail-inner {
  max-width: 1040px;
  margin: 0 auto;
  display: flex;
  gap: 32px;
  align-items: flex-start;
}

/* 本文 */
.content-col {
  flex: 1;
  min-width: 0;
  text-align: left;
}
.product-title {
  color: #AF9453;
  font-size: 26px;
  font-weight: 700;
  line-height: 1.5;
  margin-bottom: 18px;
}
.top-img {
  width: 100%;
  max-height: 460px;
  object-fit: cover;
  border-radius: 12px;
  display: block;
}
.top-img-2 {
  margin-top: 20px;
}
.content {
  margin-top: 18px;
  white-space: pre-line;
  text-align: left;
  font-size: 15px;
  line-height: 1.95;
  color: #4a463f;
}

/* 購入パネル */
.buy-panel {
  position: sticky;
  top: 20px;
  width: 300px;
  flex-shrink: 0;
  background: #fff;
  border: 1px solid #e8dfc9;
  border-radius: 14px;
  box-shadow: 0 6px 22px rgba(0, 0, 0, 0.07);
  padding: 20px 18px;
}
.buy-title {
  text-align: center;
  font-size: 15px;
  font-weight: 700;
  color: #937b3f;
  letter-spacing: 0.18em;
  padding-bottom: 14px;
  margin-bottom: 8px;
  border-bottom: 2px solid #f0ece1;
}
.buy-item {
  padding: 14px 2px;
  border-bottom: 1px solid #f4efe2;
}
.buy-item:last-child {
  border-bottom: none;
}
.buy-name {
  font-size: 14px;
  font-weight: 700;
  color: #433f38;
  margin-bottom: 10px;
  line-height: 1.4;
}
.buy-btn {
  display: block;
  text-align: center;
  background: #AF9453;
  color: #fff;
  padding: 9px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 700;
  text-decoration: none;
  transition: filter 0.15s;
}
.buy-btn:hover {
  filter: brightness(1.08);
}

@media screen and (max-width: 820px) {
  .detail-inner {
    flex-direction: column;
  }
  .content-col {
    width: 100%;
  }
  .buy-panel {
    position: static;
    width: 100%;
    order: -1;
    margin-bottom: 8px;
  }
  .top-img {
    max-height: 260px;
  }
}
</style>
